import React from 'react'

const Hobbies : React.FC = () => {
  return (
    <div>Hobbies</div>
  )
}

export default Hobbies